var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"livebox",staticClass:"live-box"},[_c('div',{staticClass:"iframe-wrapper"},[_c('iframe',{attrs:{"src":_vm.liveurl,"allow":"microphone;camera;midi;encrypted-media;display-capture *;"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }